// @flow

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    View, Pressable, useWindowDimensions, Image,
} from 'react-native';
import ServiceLogo from 'src/components/ServiceLogo';
import Text from 'src/components/CustomText/CustomText';
import Logo from 'src/assets/logo.png';
import type { Account as AccountType } from './types';
import styles from './styles';

type Props = {
    account: AccountType,
    onPress: () => void,
    active: boolean,
}

const serviceImgStyle = {
    width: 260,
};

const activeContainerStyles = [styles.accountContainer, styles.accountActive];

const mobileWrapperStyles = [styles.accountWrapper, styles.accountWrapperMobile];

const Account = ({ account, onPress, active }: Props) => {
    const { width } = useWindowDimensions();

    return (
        <Pressable style={width > 600 ? styles.accountWrapper : mobileWrapperStyles} onPress={onPress}>
            <View style={active ? activeContainerStyles : styles.accountContainer}>
                {account.is_trial ? (
                    <Image
                        source={Logo}
                        style={styles.trialLogo}
                        resizeMode="contain"
                    />
                ) : (
                    <ServiceLogo
                        serviceName={(account.name || 'cooolbox').toLowerCase()}
                        style={serviceImgStyle}
                    />
                )}
            </View>
            <Text style={styles.addressText}>
                {account.is_trial ? (
                    <FormattedMessage
                        id="trial-service"
                        defaultMessage="Trial service"
                    />
                ) : (
                    account.address || account.service_number
                )}
            </Text>
        </Pressable>
    );
};

export default Account;
